import { compact, isEqual, isNull, sortBy } from 'lodash'

export function areCompactedUniqueArraysEqual(
    array1: any,
    array2: any
): boolean {
    return isEqual(compact(sortBy(array1)), compact(sortBy(array2)))
}

export const genRanHex = (size) =>
    [...Array(size)]
        .map(() => Math.floor(Math.random() * 16).toString(16))
        .join('')

export enum ListSortDirection {
    ASC,
    DESC,
}

export function escapeCsvValue(value: unknown): string {
    const stringValue = value == null ? '' : String(value)
    const escaped = stringValue.replace(/"/g, '""')
    return `"${escaped}"`
}

export function toSnakeCaseFileSegment(value?: string | null): string {
    const normalized = (value ?? '')
        .trim()
        .toLowerCase()
        .replace(/['\u2019]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')

    return normalized || 'practice'
}
